import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'productTaskTypeImage' })
@Injectable({ providedIn: 'root' })
export class ProductTaskTypeImagePipe implements PipeTransform {
  transform(value: string): string {
    switch (value) {
      case 'task':
        return 'assets/img/icons/task_icon.svg';
      case 'issue':
        return 'assets/img/icons/issue_icon.svg';
      case 'story':
        return 'assets/img/icons/story_icon.svg';
      case 'epic':
        return 'assets/img/icons/epic_icon.svg';
      default:
        return '';
    }
  }
}
